module.exports = __webpack_public_path__ + "cement/img/蒙版组 54@2x.701e4958.png";